import Close from 'assets/icons/close.svg'
import classNames from 'classnames'

const Modal = ({
  open,
  children,
  className,
  containerClassName,
  onClose,
  showBtnColse,
  marginTop = 'mt-8 2xl:mt-10',
  hiddenBackgroundColor,
  ...rest
}) => {
  if (!open) return null
  return (
    <>
      <div
        className={classNames(
          ' justify-center items-center flex   fixed inset-0 z-50 outline-none focus:outline-none shadow-inner ' ,
          marginTop,
        )}
      >
        <div className="relative my-6 mx-auto max-w-3xl">
          <div
            className={classNames(
              'border-0 rounded shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none',
              className,
            )}
          >
            {!showBtnColse && (
              <img
                src={Close}
                width={30}
                height={20}
                onClick={onClose}
                className="ml-auto  right-2  absolute hover:cursor-pointer"
              />
            )}
            {children}
          </div>
        </div>
      </div>
      {!hiddenBackgroundColor && (
        <div className="opacity-25 md:opacity-50 fixed inset-0 z-40 bg-[#393384] "></div>
      )}
    </>
  )
}

export default Modal
